export enum BillingCountry {
  UnitedStates = 'US',
  Canada = 'CA',
  UnitedKingdom = 'UK',
  Other = 'other',
}
